import React, { ChangeEvent } from 'react';
import { Paper, SearchInput, palette } from '@dev/ee-components';
import styled from 'styled-components';

type CustomPaperProps = {
    isSearchVisible: boolean;
    searchValue: string;
    handleSearchInput(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
    handleClearSearch(): void;
    children?: React.ReactNode;
};

const StyledPaper = styled(Paper)`
    width: calc(100% + 20px);
    li:hover,
    li.MuiAutocomplete-option[data-focus='true'] {
        background-color: transparent;
    }

    .MuiButton-root {
        width: 100%;
        padding: 16px 0 16px 16px;
        border-top: 1px solid ${palette.gray[3]};

        .MuiButton-label {
            justify-content: start;
        }
    }

    .MuiAutocomplete-listbox {
        padding: 0;
    }
`;

const SearchWrapper = styled.div`
    padding: 12px;
`;

export const CustomPaper = (props: CustomPaperProps): JSX.Element => {
    const { isSearchVisible, children, handleSearchInput, searchValue, handleClearSearch } =
        props;

    return (
        <StyledPaper>
            {isSearchVisible && (
                <SearchWrapper>
                    <SearchInput
                        autoFocus
                        onChange={handleSearchInput}
                        value={searchValue}
                        onDelete={handleClearSearch}
                        style={{ padding: 12 }}
                    />
                </SearchWrapper>
            )}
            {children}
        </StyledPaper>
    );
};
